import { create } from "zustand";

interface IGifPreviewNicheState {
  gifNicheMap: Record<string, string>;
  setGifPreviewNiches: (items: { gifId: string; nicheId: string }[]) => void;
  getPreviewNiche: (gifId: string) => string | undefined;
}

export const useGifPreviewNicheStore = create<IGifPreviewNicheState>((set, get) => ({
  gifNicheMap: {},
  setGifPreviewNiches: (items) => set((state) => {
    const map = { ...state.gifNicheMap };

    items.forEach(({ gifId, nicheId }) => {
      if (!gifId || !nicheId) {
        return;
      }

      if (!map[gifId]) {
        map[gifId] = nicheId;
      }
    });

    return { gifNicheMap: map };
  }),
  getPreviewNiche: (gifId) => get().gifNicheMap[gifId],
}));
